import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
import { Checkbox } from './ui/Checkbox';
const TEAMBLIND_LOGO = 'https://cdn.magicpatterns.com/uploads/ig2VK9YG37PmXsDkFrJqFi/image.png';
const GLASSDOOR_LOGO = 'https://cdn.magicpatterns.com/uploads/oXL43uEUBnLtAB8LzmjffR/pasted-image.png';
interface SourceItem {
  label: string;
  logo?: string;
}
const FILTER_SECTIONS: {
  id: string;
  title: string;
  sources: SourceItem[];
  options: {
    id: string;
    label: string;
  }[];
}[] = [{
  id: 'layoffs',
  title: 'Layoff History',
  sources: [{
    label: 'Layoffs.fyi'
  }, {
    label: 'Blind',
    logo: TEAMBLIND_LOGO
  }],
  options: [{
    id: 'l1',
    label: 'No layoffs (2yr)'
  }, {
    id: 'l2',
    label: 'No layoffs (5yr)'
  }, {
    id: 'l3',
    label: 'Any'
  }]
}, {
  id: 'benefits',
  title: 'Benefits',
  sources: [{
    label: 'Company website'
  }, {
    label: 'Public data'
  }],
  options: [{
    id: 'b1',
    label: 'Parental leave (16+ wks)'
  }, {
    id: 'b2',
    label: 'Trans-inclusive healthcare'
  }, {
    id: 'b3',
    label: 'Disability accommodations'
  }, {
    id: 'b4',
    label: 'Partner/domestic partner healthcare'
  }]
}, {
  id: 'political',
  title: 'Political Donations',
  sources: [{
    label: 'OpenSecrets'
  }, {
    label: 'SEC filings'
  }],
  options: [{
    id: 'p1',
    label: 'No anti-LGBTQ donations'
  }, {
    id: 'p2',
    label: 'No anti-abortion donations'
  }, {
    id: 'p3',
    label: 'Supports progressive causes'
  }]
}, {
  id: 'sentiment',
  title: 'Employee Sentiment',
  sources: [{
    label: 'Blind',
    logo: TEAMBLIND_LOGO
  }, {
    label: 'Glassdoor',
    logo: GLASSDOOR_LOGO
  }],
  options: [{
    id: 's1',
    label: 'Teamblind rating 3.5+'
  }, {
    id: 's2',
    label: 'Glassdoor 4.0+'
  }, {
    id: 's3',
    label: 'Low toxicity reports'
  }]
}, {
  id: 'dei',
  title: 'DEI Commitment',
  sources: [{
    label: 'Blind',
    logo: TEAMBLIND_LOGO
  }, {
    label: 'Company website'
  }],
  options: [{
    id: 'd1',
    label: 'Published DEI report'
  }, {
    id: 'd2',
    label: 'Diverse leadership (30%+)'
  }, {
    id: 'd3',
    label: 'ERG programs'
  }, {
    id: 'd4',
    label: 'Pay equity audit'
  }]
}, {
  id: 'worklife',
  title: 'Work-Life Balance',
  sources: [{
    label: 'Glassdoor',
    logo: GLASSDOOR_LOGO
  }, {
    label: 'Blind',
    logo: TEAMBLIND_LOGO
  }],
  options: [{
    id: 'w1',
    label: 'Flexible hours'
  }, {
    id: 'w2',
    label: 'Remote options'
  }, {
    id: 'w3',
    label: 'No crunch culture'
  }]
}];
export function FilterSidebar() {
  return <aside className="w-full md:w-[260px] shrink-0 border-r border-border bg-background h-[calc(100vh-85px)] overflow-y-auto hidden md:block" data-id="element-121">
      <div className="p-4 flex items-center justify-between border-b border-border/50 sticky top-0 bg-background z-10" data-id="element-122">
        <h2 className="font-mono text-xs font-semibold uppercase tracking-wider text-foreground" data-id="element-123">
          Filters
        </h2>
        <button className="text-[11px] font-mono text-muted-foreground hover:text-foreground transition-colors" data-id="element-124">
          Clear all
        </button>
      </div>

      <div className="p-2" data-id="element-125">
        <Accordion type="multiple" defaultValue={['benefits', 'dei', 'political']} className="w-full" data-id="element-126">
          {FILTER_SECTIONS.map(section => <AccordionItem value={section.id} key={section.id} className="border-b-0" data-id="element-127">
              <AccordionTrigger className="px-2 py-2.5 hover:no-underline hover:bg-muted/50 rounded-sm transition-colors text-[13px] font-medium" data-id="element-128">
                <div className="flex flex-col items-start gap-1" data-id="element-129">
                  <span data-id="element-130">{section.title}</span>
                  <div className="flex items-center gap-1.5 flex-wrap" data-id="element-131">
                    {section.sources.map((src, i) => <span key={i} className="flex items-center gap-1 text-[10px] font-mono text-muted-foreground font-normal" data-id="element-132">
                        {src.logo && <img src={src.logo} alt={src.label} className="w-3 h-3 rounded-[1px] object-cover" data-id="element-133" />}
                        <span data-id="element-134">{src.label}</span>
                        {i < section.sources.length - 1 && <span className="text-border ml-0.5" data-id="element-135">·</span>}
                      </span>)}
                  </div>
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-2 pb-3 pt-1" data-id="element-136">
                <div className="space-y-2.5" data-id="element-137">
                  {section.options.map(option => <div key={option.id} className="flex items-start space-x-2" data-id="element-138">
                      <Checkbox id={option.id} className="mt-0.5 h-3.5 w-3.5 rounded-[2px]" data-id="element-139" />
                      <label htmlFor={option.id} className="text-xs font-normal leading-tight peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer" data-id="element-140">
                        {option.label}
                      </label>
                    </div>)}
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </aside>;
}